import {
  clearSearchCondition,
  changeCheckbox,
  handleSearch,
  searchInit,
  prefectureLinkOnClick,
  setSubPrefectureAccordionButtonEvent
} from "../../lib/search/search";
import {__} from "../../lib/lang/translator";

document.addEventListener('DOMContentLoaded', function () {

  const checkboxes = document.querySelectorAll('[data-search-container] input[type="checkbox"]');
  const resetButton = document.querySelectorAll('.clearForm');
  const townModalButtons = document.querySelectorAll('.town_modal_btn')
  const searchButtons = document.querySelectorAll('.search-button');

  // 検索条件を格納（オブジェクトとして初期化）
  let searchCondition = {
    prefecture: [prefecture],
  };

  searchInit(searchCondition);

  //選択されているエリアのチェックボックスと地図をアクティブにする
  !function () {
    // 選択されているチェックボックスを取得
    const selectedAreas = document.querySelectorAll('[data-search-area] input[type="checkbox"]:checked');

    selectedAreas.forEach(checkbox => {
      // 選択されたチェックボックスの親要素をアクティブにする
      const parent = checkbox.parentElement;
      parent.classList.add('act');

      // チェックボックスに対応する地図の要素を取得
      const areaMapFigureGroupElement = document.getElementById('area-map-figure-group')?.children[parent.id];

      // 対応する地図があればアクティブにする
      if (areaMapFigureGroupElement) {
        areaMapFigureGroupElement.classList.add('act');
      }
    });
  }();

  //地図を初期化する関数
  const initMap = () => {
    // エリアマップのすべての子要素を取得
    const childElements = areaMapFigureGroup.children;

    // 各子要素から'act'クラスを取り除く
    for (let i = 0; i < childElements.length; i++) {
      childElements[i].classList.remove('act');
    }
  }

  // チェックボックスにイベントを付与
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      changeCheckbox(searchCondition, checkbox);
    });
  });

  // リセットボタンにイベントを付与
  resetButton.forEach(function (button) {
    button.addEventListener('click', function () {
      clearSearchCondition(searchCondition, checkboxes);
      document.querySelector('#area-map-figure-group') && initMap();
    });
  });

  //検索ボタンを押した時の処理
  searchButtons.forEach(searchButton => {
    searchButton.addEventListener('click', function () {
      handleSearch(searchCondition);
    });
  })

  //町一覧モーダルが開いている時の処理
  townModalButtons.forEach(button => {
    button.addEventListener('click', event => {
      const townsList = document.querySelector('.towns_list');
      const modalCityName = document.querySelector('.modal_city_name');
      const modalOfficeCount = document.querySelector('.modal_office_count');
      const modalOfficeCountCase = document.querySelector('[data-remodal-id=modal_1] [data-modal-office-count-case]');
      //モーダルの中身を初期化
      townsList.innerHTML = '';
      modalCityName.innerHTML = '';
      modalOfficeCount.innerHTML = 'Loading';
      modalOfficeCount.classList.add('loading');

      //クリックした市区の情報を取得
      const cityCode = event.currentTarget.getAttribute('data-cityCode');
      const cityName = event.currentTarget.getAttribute('data-cityName');
      const count = event.currentTarget.getAttribute('data-count');

      //その市区の町情報を取得
      axios.get(route('web.search.town', {cityCode: cityCode}))
        .then(response => {
          response.data.townData.forEach((item, index) => {
            //取得した町情報を元に要素を作成
            const div = document.createElement('div');
            div.className = 'check chin modal_check_area';

            const input = document.createElement('input');
            input.type = 'checkbox';
            input.id = `town${index}`;
            input.name = 'address_code';
            input.value = `${item["address_code"]}_${item["townName"]}`;

            const label = document.createElement('label');
            label.setAttribute('for', `town${index}`);

            // @TODO 件数を表示する場合はコメントアウトを外す
            // label.innerHTML = `${item["townName"]}${__('(')}<span>${item["count"]}</span>${__('cases', item["count"])}${__(')')}`;
            label.innerHTML = `${item["townName"]}`;

            //既に選択されている町の場合
            if (searchCondition["address_code"] && searchCondition["address_code"].includes(`${item["address_code"]}_${item["townName"]}`)) {
              input.checked = true;
            }

            //要素を追加
            div.appendChild(input);
            div.appendChild(label);
            townsList.appendChild(div);
            modalCityName.innerHTML = cityName;
            modalOfficeCount.classList.remove('loading');
            modalOfficeCount.innerHTML = count;
            modalOfficeCountCase.innerHTML = __('cases_found', count)
          });

          //チェックボックスにイベントを付与
          const townCheckBoxes = document.querySelectorAll('[data-remodal-id=modal_1] input[type="checkbox"]')
          townCheckBoxes.forEach(checkbox => {
            checkbox.addEventListener('change', async function () {
                await changeCheckbox(searchCondition, checkbox);

                if (!searchCondition["address_code"]) {
                  modalOfficeCount.innerHTML = count;
                  modalOfficeCountCase.innerHTML = __('cases_found', count);
                }
              }
            )
          });

          const modalResetButton = document.querySelector('[data-remodal-id=modal_1] .town_clearForm');

          //モーダル内のリセットボタンを押した時の処理
          modalResetButton.addEventListener('click', async function () {
            const modalCheckBoxes = document.querySelectorAll('[data-remodal-id=modal_1] input[type="checkbox"]');
            modalCheckBoxes.forEach(checkbox => {
              checkbox.checked = false;
              checkbox.dispatchEvent(new Event('change'));
            });
          });

          const modalSearchButton = document.querySelector('[data-remodal-id=modal_1] .search-button');

          modalSearchButton.addEventListener('click', function () {
            handleSearch(searchCondition);
          });

        })
        .catch(error => {
          console.error('Error:', error.response.data);
        });
    });
  });


  //地図の要素クリック
  const areaMapFigureGroup = document.querySelector('#area-map-figure-group');
  areaMapFigureGroup && areaMapFigureGroup.addEventListener('click', function (event) {

    const gElement = event.target.closest('g');

    if (gElement) {
      const id = gElement.getAttribute('id');
      const checkboxElement = document.querySelector(`#${id} input`);
      const relatedElementInAreaChecks = document.querySelector(`#area_checks #${id}`);

      if (gElement.classList.contains('act')) {
        gElement.classList.remove('act');
        if (relatedElementInAreaChecks) {
          relatedElementInAreaChecks.classList.remove('act');
        }
        if (checkboxElement) {
          checkboxElement.checked = false;
          changeCheckbox(searchCondition, checkboxElement);
        }
      } else {
        if (relatedElementInAreaChecks) {
          relatedElementInAreaChecks.classList.add('act');
        }
        if (checkboxElement) {
          checkboxElement.checked = true;
          changeCheckbox(searchCondition, checkboxElement);

        }
        if (relatedElementInAreaChecks) {
          gElement.classList.add('act');
        }
      }
    }

  });

  // 地図の文字クリック
  document.querySelectorAll('#area-map-text-group g').forEach(element => {
    element.addEventListener('click', function () {
      const id = this.getAttribute('id'); //id取ってくる
      const id2 = "#" + id; //idをアンカーに
      const id3 = id2.replace("-text", ''); //idからtextをマイナス
      const id4 = id3 + " input"; //idにinputをたす

      const areaChecksElement = document.querySelector('#area_checks').querySelector(id3);
      const areaMapFigureGroupElement = document.querySelector('#area-map-figure-group').querySelector(id3);

      if (areaChecksElement && areaMapFigureGroupElement) {
        if (areaChecksElement.classList.contains('act') && areaMapFigureGroupElement.classList.contains('act')) {
          areaChecksElement.classList.remove('act');
          areaMapFigureGroupElement.classList.remove('act');
          const checkbox = document.querySelector(id4);
          if (checkbox) {
            checkbox.checked = false;
            changeCheckbox(searchCondition, checkbox);
          }
        } else {
          areaChecksElement.classList.add('act');
          areaMapFigureGroupElement.classList.add('act');
          const checkbox = document.querySelector(id4);
          if (checkbox) {
            checkbox.checked = true;
            changeCheckbox(searchCondition, checkbox);
          }
        }
      }
    });
  });

  // 異なる都道府県検索へページ遷移後も共通の条件を維持する
  prefectureLinkOnClick();

  // 全ての都道府県を見るボタンクリックごとに主要都道府県以外の表示・非表示を切り替えるイベントを登録
  setSubPrefectureAccordionButtonEvent();
});
